import { Trans } from "@lingui/react/macro";

import sproudImageUrl from "@/assets/images/sproud.webp?url";

export default function SignupQuote() {
  return (
    <div className="p-6 hidden md:block text-white">
      <div
        style={{ backgroundImage: `url(${sproudImageUrl})` }}
        className="size-full rounded-2xl bg-cover bg-center overflow-hidden"
      >
        <div className="flex flex-col gap-3 items-center justify-end p-8 size-full bg-linear-to-b from-neutral-950/25 to-neutral-950/50">
          <div className="p-4 rounded-2xl bg-white/25 backdrop-blur-lg ring-2 ring-white/30 flex flex-col gap-8 w-full">
            <q className="text-2xl/normal font-medium max-w-xl">
              <Trans>
                We can instantly track anything, from influencers to industry
                trends, and get real-time insights without the manual work.
              </Trans>
            </q>

            <div className="flex flex-col gap-0.5">
              <p className="font-semibold">
                <Trans>Hanna Palmström</Trans>
              </p>

              <p className="text-white/80">
                <Trans>Brand Activation Executive at Sproud</Trans>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
